export enum TenantStatus {
  DRAFT = 'DRAFT',
  CONFIRMED = 'CONFIRMED',
}

export const ORGANIZATION_STATUS_COLOR: Record<TenantStatus, string[]> = {
  [TenantStatus.DRAFT]: ['var(--link)', 'var(--light-link)'],
  [TenantStatus.CONFIRMED]: ['var(--success)', 'var(--success-hover)'],
};

export enum OrgType {
  ROOT = 'ROOT',
  NORMAL = 'NORMAL',
  CLINIC = 'CLINIC',
}
